import React from 'react';
import { NavLink } from 'react-router-dom';

// Underline tabs (handoff bundle's navigation/Tabs) built on react-router's
// NavLink — the app's nav is URL-driven in both targets (MemoryRouter in the
// side panel, BrowserRouter in the webapp). Active styling keys off the
// aria-current attribute NavLink sets, so the className stays static and the
// 2.5px brand bar scales in on activation.

export interface TabLinkProps {
  to: string;
  label: string;
  /** Shown instead of label below the `md` container breakpoint. */
  shortLabel?: string;
  icon?: React.ReactNode;
  /** Small mono count chip (e.g. cards due). Hidden when undefined or 0. */
  count?: number;
  end?: boolean;
}

export function TabLink({ to, label, shortLabel, icon, count, end }: TabLinkProps) {
  return (
    <NavLink
      to={to}
      end={end}
      className={[
        'group relative inline-flex items-center gap-1 whitespace-nowrap rounded px-2 py-1',
        'text-sm font-medium text-slate-500 transition-colors duration-200 ease-out',
        'hover:text-slate-900',
        'aria-[current=page]:text-blue-700',
        // Underline bar: scales in under the active tab.
        'after:absolute after:inset-x-1.5 after:-bottom-px after:h-[2.5px]',
        'after:origin-center after:scale-x-0 after:rounded-full after:bg-blue-600',
        'after:transition-transform after:duration-200 after:ease-out',
        'aria-[current=page]:after:scale-x-100',
      ].join(' ')}
    >
      {icon}
      {shortLabel ? (
        <>
          <span className="@md:hidden">{shortLabel}</span>
          <span className="hidden @md:inline">{label}</span>
        </>
      ) : (
        label
      )}
      {typeof count === 'number' && count > 0 && (
        <span
          className={[
            'rounded-full bg-slate-100 px-1.5 font-mono text-[10px] font-semibold text-slate-600',
            'group-aria-[current=page]:bg-blue-50 group-aria-[current=page]:text-blue-700',
          ].join(' ')}
        >
          {count}
        </span>
      )}
    </NavLink>
  );
}
